import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import Information from './components/show/Information';
import LineItems from './components/show/LineItems';
import ShowContainer from '../../shared/components/show/showContainer';

const showInded = () => (
  <Container>
    <ShowContainer>
      <Information />
      <hr />
      <LineItems />
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(showInded));
